import axios from 'axios'
import { getLocalJsonCache } from '@/utils/cache'

import router from '@/router'


// 存储所有正在进行的请求控制器
const pendingRequests = new Map()

// 创建axios实例
const request = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL || '/prod-api',
  timeout: 10000,
})

// 生成请求唯一标识
const generateRequestKey = (config) => {
  return `${config.method}_${config.url}_${JSON.stringify(config.params)}_${JSON.stringify(config.data)}`
}

// 添加请求到待处理列表
function addPendingRequest (config) {
  const requestKey = generateRequestKey(config)
  // 如果已经存在，先取消之前的请求
  if (pendingRequests.has(requestKey)) {
    const controller = pendingRequests.get(requestKey)
    controller?.abort()
  }

  // 创建新的控制器
  const controller = new AbortController()
  config.signal = controller.signal
  pendingRequests.set(requestKey, controller)
}

// 移除已完成的请求
function removePendingRequest (config) {
  const requestKey = generateRequestKey(config)
  pendingRequests.delete(requestKey)
}

// 取消所有请求
export const cancelAllRequests = () => {
  pendingRequests.forEach((controller) => {
    controller.abort()
  })
  pendingRequests.clear()
}

// 请求拦截器
request.interceptors.request.use(
  (config) => {
    // 添加请求到待处理列表
    addPendingRequest(config)

    // 可以在这里添加认证token等
    const token = getLocalJsonCache('userInfo')?.token
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    config.headers.clientId = import.meta.env.VITE_CLIENT_ID
    return config
  },
  (error) => {
    return Promise.reject(error)
  },
)

// 响应拦截器
request.interceptors.response.use(
  (response) => {
    removePendingRequest(response.config)

    // 【新增】判断是否为 blob 类型响应（通常用于文件下载/导出）
    const responseType = response.config.responseType
    if (responseType === 'blob' || responseType === 'arraybuffer') {
      // 直接返回原始数据，让调用方处理 blob
      return response.data
    }

    // 普通 JSON 响应处理
    const { code, data, msg } = response.data

    if (code === 200) {
      // 确保返回类型匹配
      return response.data
    } else if (code === 401) {
      // 成功时返回完整的业务数据
      router.replace('/login')
      return Promise.reject(new Error('token失效'))
    } else if (code === 403) {
      // 成功时返回完整的业务数据
      router.replace('/403')
      return Promise.reject(new Error('403 权限错误'))
    } else {
      // 可以根据业务需求处理不同的错误码
      // showFailToast(msg || '请求失败')
      return Promise.reject(new Error(msg || '请求失败'))
    }
  },
  (error) => {
    console.log('🚀 ~ error:', error)
    // 如果是取消请求的错误，直接返回
    if (error.message == 'canceled') {
      return Promise.reject(error)
    }

    // 【优化】防止 error.config 为 undefined 时报错
    if (error.config) {
      removePendingRequest(error.config)
    }

    // 避免在身份验证失败时显示网络错误
    if (error.message !== 'token失效') {
      // showFailToast('网络错误')
    }
    return Promise.reject(error)
  },
)

export default request
